import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { withdrawRequest } from "../../redux/slice/passbookSlice";
import { IoClose } from "react-icons/io5";

const Redeem = ({ reward, redeemtoggle }) => {
  const dispatch = useDispatch();
  const [upiId, setUpiId] = useState("");
  const [bankDetails, setBankDetails] = useState({
    accountName: "",
    accountNumber: "",
    bankName: "",
    ifscCode: ""
  });
  const [paymentMethod, setPaymentMethod] = useState("upi");
  
  const handleBankChange = (e) => {
    setBankDetails({
      ...bankDetails,
      [e.target.name]: e.target.value
    });
  };

  const onFinish = () => {
    let paymentDetails = {};
    let method = "";

    if (reward.rewardMethod === "cash") {
      if (paymentMethod === "upi") {
        method = "paypal";
        paymentDetails = { upiId: upiId };
      } else {
        method = "bank_transfer";
        paymentDetails = {
          accountName: bankDetails.accountName,
          accountNumber: bankDetails.accountNumber,
          bankName: bankDetails.bankName,
          ifscCode: bankDetails.ifscCode
        };
      }
    } else {
      method = "gift_card";
      paymentDetails = {
        giftCardType: reward.title
      };
    }

    const withdrawDetails = {
      amount: reward.points,
      currency: "INR",
      paymentMethod: method,
      paymentDetails: paymentDetails
    };

    dispatch(withdrawRequest(withdrawDetails));
    redeemtoggle();  
  };

  return (
    <div className=" redeem-info-card">
      <div className="card-shadow"></div>
      <div className="login-card">
        <span className="close-btn" onClick={redeemtoggle}>
          <IoClose />
        </span>
        <div className="login-card-header mb-4 d-flex align-items-center justify-content-between">
          <h6 className="h6 mb-0 text-center">
            {reward.rewardMethod === "cash" 
              ? "Your cash will be transferred within 7 days."
              : "Your gift card will be delivered to your inbox within 7 days."}
          </h6>
        </div>
        
        {reward.rewardMethod === "cash" && (
          <>
            <div className="mb-3">
              <label className="form-label">Payment Method</label>
              <select 
                className="form-control"
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
              >
                <option value="upi">UPI</option>
                <option value="bank_transfer">Bank Transfer</option>
              </select>
            </div>

            {paymentMethod === "upi" ? (
              <div className="mb-3">
                <label className="form-label">UPI ID</label>
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Enter your UPI ID (e.g., username@upi)"
                  value={upiId}
                  onChange={(e) => setUpiId(e.target.value)}
                />
              </div>
            ) : (
              <>
                <div className="mb-3">
                  <label className="form-label">Account Holder Name</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Enter account holder name"
                    name="accountName"
                    value={bankDetails.accountName}
                    onChange={handleBankChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Account Number</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Enter account number"
                    name="accountNumber"
                    value={bankDetails.accountNumber}
                    onChange={handleBankChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Bank Name</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Enter bank name"
                    name="bankName"
                    value={bankDetails.bankName}
                    onChange={handleBankChange}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">IFSC Code</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Enter IFSC code"
                    name="ifscCode"
                    value={bankDetails.ifscCode}
                    onChange={handleBankChange}
                  />
                </div>
              </>
            )}
          </>
        )}
        
        <p className="text-white">If you agree, please click on the Send button</p>
        <button className="btn" onClick={onFinish}>
          Send
        </button>
      </div>
    </div>
  );
};

export default Redeem;
